(function () {

    'use strict';

    if (typeof window === 'undefined') {
        module.exports = exports(
            require('./metric.js'),
            require('./search.js'),
            require('./property.js'),
            require('../../enums/metrics.js'),
            require('lodash')
        );
    } else {
        RivalIQ.metric.graph = exports(
            RivalIQ.metric,
            RivalIQ.metric.search,
            RivalIQ.metric.property,
            RivalIQ.enums,
            window._
        );
    }

    function exports(metricFn, search, property, enums, _) {

        const stackableTimeAnalysisModes = [
            enums.timeAnalysisMode.MAIN_PERIOD,
            enums.timeAnalysisMode.COMPARE_PERIOD
        ];

        // Summable metrics can be sensically displayed as stacked bars or pie
        // charts
        function isSummable(metric) {
            return property.isSummable(metric.property) &&
                // Undefined treated as MAIN_PERIOD for backwards compatibility
                (_.isUndefined(metric.timeAnalysisMode) ||
                _.includes(stackableTimeAnalysisModes, metric.timeAnalysisMode));
        }

        // Returns true if the metric has a historic component. This is true
        // for most of our metrics, but text metrics like `overview` are currently
        // not tracked over time
        function hasHistory(metric) {
            return property.isNumeric(metric) && search.getPropertyValue(metric, 'hasHistory');
        }

        return {
            isSummable: isSummable,
            hasHistory: hasHistory
        };
    }
})();
